import { BulkFilesConfirmation } from 'v2/models';
import { BulkFilesUploadForm } from '../../../types';

export function buildBulkFilesConfirmations(
  data: BulkFilesUploadForm
): BulkFilesConfirmation[] {
  const bulkFilesConfirmation = data.bulkUploadFiles
    .map(({ dataVendor, file }) => {
      if (dataVendor?.id === undefined || file.fileId === undefined) return;

      const bulkFilesConfirmation: BulkFilesConfirmation = {
        data_vendor_pk: dataVendor.id,
        type: data.type,
        files: [file.fileId],
      };

      return bulkFilesConfirmation;
    })
    .filter(
      (bulkFilesConfirmation): bulkFilesConfirmation is BulkFilesConfirmation =>
        Boolean(bulkFilesConfirmation)
    );

  return bulkFilesConfirmation;
}
